module.exports = __webpack_public_path__ + "img/yurt-logo-1.1a52641e.png";